export interface GlossaryEntry {
    kpi: string;
    definition: string;
}

const byKpiName = new Intl.Collator('en', { sensitivity: 'base' });

/** What each Road to Rewards KPI means, sorted A to Z by KPI name. */
export const ROAD_TO_REWARDS_GLOSSARY: GlossaryEntry[] = [
    {
        kpi: 'Enrollments',
        definition: 'Count of enrollments since campaign launched.',
    },
    {
        kpi: 'Enrollment by Day',
        definition:
            'Total count of enrollments divided by the number of days the campaign is active.',
    },
    {
        kpi: 'Active Member',
        definition:
            'Unique count of members that are fully enrolled and have at least one transaction.',
    },
    {
        kpi: 'New Active App Member',
        definition:
            'Unique count of members that are fully enrolled and have at least one transaction. Users downloaded the app and enrolled after launch September 15th.',
    },
    {
        kpi: 'Enrollment by BU',
        definition: 'Enrolled members split by business unit.',
    },
    {
        kpi: 'Issued Members',
        definition: 'Unique members who have received at least 1 coupon.',
    },
    {
        kpi: 'Issued Coupons',
        definition:
            'Issued Coupons is the total of coupons issued in a given period.',
    },
    {
        kpi: 'Member Creation Date',
        definition:
            'Member Creation Date is the date when the member is first created in the Circle K / Couche-Tard app.',
    },
    {
        kpi: 'Member Redemption Rate %',
        definition:
            'Percentage of members issued a coupon in a given period who have redeemed at least one coupon since. It follows the members issued in the period, so it is not Redeemed Members divided by Issued Members for the same period.',
    },
    {
        kpi: 'Redeemed Members',
        definition: 'Count of unique members who have redeemed a coupon.',
    },
    {
        kpi: 'Coupon Redemption Rate %',
        definition:
            'Percentage of coupons issued in a given period that have been redeemed since. It follows the coupons issued in the period, so it is not Redeemed Coupons divided by Issued Coupons for the same period: Redeemed Coupons counts redemptions made in the period, whenever the coupon was issued.',
    },
    {
        kpi: 'Phone Opt-Out (No Longer Contact by Phone)',
        definition:
            'Phone Opt-Out (No Longer Contact by Phone) is a flag that represents if a member chooses to not receive contact by Phone.',
    },
    {
        kpi: 'Campaign store visits',
        definition:
            'Count of in-store transactions registered at the campaign LIFT screen.',
    },
    {
        kpi: 'Campaign spend',
        definition:
            'Transaction value in baskets generated by campaign members at the LIFT screen.',
    },
    {
        kpi: 'Average spent by member',
        definition: 'Average transaction value per enrolled member.',
    },
    {
        kpi: 'Average spent by transaction',
        definition:
            'Average transaction value across all qualifying transactions.',
    },
    {
        kpi: 'Repeat visit rate',
        definition:
            '% of enrolled members who recorded more than one qualifying visit.',
    },
    {
        kpi: 'Units/transaction',
        definition:
            'Average number of items purchased per qualifying LIFT transaction.',
    },
    {
        kpi: 'Returning members',
        definition:
            'Count of enrolled members who recorded more than one qualifying visit.',
    },
    {
        kpi: 'Coupon expiry rate %',
        definition:
            'Percentage of issued coupons that expired without being redeemed in store.',
    },
    {
        kpi: 'Share of campaign',
        definition:
            "% of the campaign's active members in the selected period and region who belong to this segment. Segments do not overlap, so the four shares add up to 100%.",
    },
].sort((a, b) => byKpiName.compare(a.kpi, b.kpi));
